import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DataTableColumn, PaginatorStatus, SortConfiguration } from '../../generics/data-table/data-table.component';
import { CustomTableFilter } from '../../generics/table-filter/table-filter.component';
import { ErrorResponse } from 'src/app/models/error.model';
import { Zona } from 'src/app/models/zona.model';
import { ZonasService } from 'src/app/services/zonas.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-zonas',
    templateUrl: './zonas.component.html',
    styleUrls: ['./zonas.component.scss']
})
export class ZonasComponent implements OnInit {

    @ViewChild('actionsColumnTemplate', { static: true })
    actionsColumnTemplate: TemplateRef<any>;

    @ViewChild('activoColumnTemplate', { static: true })
    activoColumnTemplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Nombre', prop: 'nombre', sortable: true },
        { name: 'Aclaración', prop: 'aclaracion', sortable: true },
        { name: 'Estado', width: '100px' },
        { name: '', width: '100px' }
    ];

    sortConfiguration?: SortConfiguration;
    zonas: Zona[] = [];

    filters: CustomTableFilter[] = [
        { key: 'nombre', description: 'Nombre', type: 'STRING' }
    ];
    filterValues: any = {};

    constructor(
        private zonasService: ZonasService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === 'Estado').template = this.activoColumnTemplate;
        this.columns.find(col => col.name === '').template = this.actionsColumnTemplate;
        this.getZonas();
    }

    getZonas() {
        this.zonasService.getZonas(
            this.paginatorStatus.page,
            this.paginatorStatus.itemsPerPage,
            this.sortConfiguration ? [this.sortConfiguration] : [],
            this.filterValues
        ).subscribe({
            next: response => {
                this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.zonas = response.body;
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener zonas', error.error?.descripcion)
        });
    }

    updatePage(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getZonas();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getZonas();
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getZonas();
    }

    deleteZona(zona: Zona) {
        const dialog = this.utilsService.confirm(
            '¿Dar de baja esta zona?',
            `La zona "${zona.nombre}" quedará inactiva.`
        );
        dialog.afterClosed().subscribe(confirmed => {
            if (confirmed) {
                this.zonasService.deleteZona(zona.id).subscribe({
                    next: () => {
                        this.utilsService.alert('Zona dada de baja', `La zona "${zona.nombre}" fue dada de baja correctamente.`);
                        this.getZonas();
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al dar de baja la zona', error.error?.descripcion)
                });
            }
        });
    }
}
